// Hideo - Google Trends comparison on the Keywords page (user request, 25/10/2026). Up to 5 keywords, an area, a period
// and the kind of search, opened on the Google Trends site in a new tab (interest over time and related searches).
// Google no longer lets its charts be shown inside other sites (checked 2/11/2026: its embeddable charts answer 429 with
// X-Frame-Options: SAMEORIGIN, Google's own embed_loader.js included), so Hideo no longer embeds them. Nothing is
// stored: the list and the options live in the keywords store while the app is open.
import { LANG, type Lang } from '../i18n'
import { kwNorm } from './keywords'

/** Most keywords Google Trends compares */
export const TRENDS_MAX = 5
/** Area: Italy or the whole world */
export type TrendsGeo = 'IT' | ''
/** Period, as Google Trends writes it */
export type TrendsTime = 'now 7-d' | 'today 1-m' | 'today 12-m' | 'today 5-y'
/** Searches on YouTube or on Google (web search: Google's empty property) */
export type TrendsProp = 'youtube' | ''
export interface TrendsOpts { geo: TrendsGeo; time: TrendsTime; prop: TrendsProp }
/** Starting options: Italy for the Italian UI, worldwide for English; the last 12 months; YouTube searches */
export const trendsDefaults = (lang: Lang = LANG): TrendsOpts => ({ geo: lang === 'it' ? 'IT' : '', time: 'today 12-m', prop: 'youtube' })

/** The query of the Google Trends site for these keywords and options */
function exploreQuery(kws: readonly string[], o: TrendsOpts): string {
  const p = new URLSearchParams()
  p.set('date', o.time)
  if (o.geo) p.set('geo', o.geo)
  if (o.prop) p.set('gprop', o.prop)
  p.set('q', kws.join(','))
  return p.toString()
}

/** The same search on the Google Trends site (new tab) */
export const trendsSiteUrl = (kws: readonly string[], o: TrendsOpts, lang: Lang = LANG): string =>
  `https://trends.google.com/trends/explore?${exploreQuery(kws, o)}&hl=${lang}`

/** The list with one keyword added (normalised text; already there or the list full: unchanged) */
export function trendsAdd(list: readonly string[], text: string): string[] {
  const k = kwNorm(text)
  if (!k || list.includes(k) || list.length >= TRENDS_MAX) return [...list]
  return [...list, k]
}
